const playVideo = (iframe: HTMLIFrameElement) => {
	iframe.src = iframe.dataset.src || '';
	if (iframe.src?.includes('vimeo')) {
		const player = new window.Vimeo.Player(iframe);
		player.play();
	}
};

document.querySelectorAll('.media').forEach((block) => {
	const iframe = block.querySelector('iframe');
	const videoInlineButton = block.querySelector('.video-button.inline');
	const videoLightboxButton = block.querySelector('.video-button.lightbox');
	const isAutoplay = block.classList.contains('media--inline_autoplay');

	if (isAutoplay && iframe) {
		const player = new window.Vimeo.Player(iframe);
		player.on('play', () => {
			block.classList.add('active');
		});
	}

	if (videoInlineButton && iframe) {
		videoInlineButton.addEventListener('click', () => {
			block.classList.add('active');
			playVideo(iframe);
		});
	}

	if (videoLightboxButton) {
		const modalId = videoLightboxButton.getAttribute('aria-controls');
		if (!modalId) return;

		const modalIframe = document.getElementById(modalId)?.querySelector('iframe');
		if (!modalIframe) return;

		videoLightboxButton.addEventListener('click', () => {
			playVideo(modalIframe);
		});
	}
});
